export const PAY_METHOD = Object.freeze({
  CREDIT_CARD: '1',
  PIX: '2',
  BILLET: '3',
  DEBIT_CARD: '4',
  RECURRING_CREDIT_CARD: '5',
});

export const shouldRequireCreditCardData = (payment) =>
  payment?.pay_method === PAY_METHOD.CREDIT_CARD && payment?.requiresCardData !== false;

export const formatPayMethod = (id) => {
  const payMethod = String(id);
  if (payMethod === PAY_METHOD.CREDIT_CARD) return 'Cartão de Crédito';
  if (payMethod === PAY_METHOD.PIX) return 'Pix';
  if (payMethod === PAY_METHOD.BILLET) return 'Boleto';
  if (payMethod === PAY_METHOD.DEBIT_CARD) return 'Cartão de Débito';
  if (payMethod === PAY_METHOD.RECURRING_CREDIT_CARD) return 'Cartão de Crédito Recorrente';
};
